'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _dec2, _class2, _class3, _temp3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _schoollevels = require('redux/modules/schoollevels');

var _reactRouter = require('react-router');

var _reactDraggableList = require('react-draggable-list');

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

var _components = require('components');

var _copy = require('redux/modules/copy');

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SchoolLevelListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SchoolLevelListItem, _Component);

  function SchoolLevelListItem() {
    (0, _classCallCheck3.default)(this, SchoolLevelListItem);
    return (0, _possibleConstructorReturn3.default)(this, (SchoolLevelListItem.__proto__ || (0, _getPrototypeOf2.default)(SchoolLevelListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(SchoolLevelListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dragHandle = _props.dragHandle,
          item = _props.item,
          itemSelected = _props.itemSelected;

      var dragged = itemSelected > 0.75;
      var styles = require('./SchoolLevels.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.schoolLevelListItem + (dragged ? ' dragged' : '') },
        dragHandle(_react2.default.createElement(
          'div',
          null,
          item.label
        ))
      );
    }
  }]);
  return SchoolLevelListItem;
}(_react.Component), _class.propTypes = {
  dragHandle: _react.PropTypes.func.isRequired,
  item: _react.PropTypes.object.isRequired,
  itemSelected: _react.PropTypes.number.isRequired
}, _temp);
var SchoolLevels = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _schoollevels.isLoaded)(getState())) {
      return _promise2.default.all([dispatch((0, _auth.load)()), dispatch((0, _schoollevels.load)())]);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    copying: state.copy.copying,
    user: state.auth.user
  };
}), _dec(_class2 = _dec2(_class2 = (_temp3 = _class3 = function (_Component2) {
  (0, _inherits3.default)(SchoolLevels, _Component2);

  function SchoolLevels() {
    var _ref2;

    var _temp2, _this2, _ret;

    (0, _classCallCheck3.default)(this, SchoolLevels);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SchoolLevels.__proto__ || (0, _getPrototypeOf2.default)(SchoolLevels)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
      sorting: false,
      copyLevelModalVisible: false,
      copyLevelModalObject: {},
      copying: false
    }, _this2.componentWillReceiveProps = function (nextProps) {
      if (_this2.props.copying && !nextProps.copying) {
        _this2.setState({
          copyLevelModalVisible: false
        });
        _this2.props.dispatch((0, _schoollevels.load)());
      }
    }, _this2.onListChange = function (newList, movedItem, oldIndex, newIndex) {
      console.log(newList);
      console.log(movedItem);
      console.log(oldIndex);
      console.log(newIndex);
    }, _this2.handleStartSorting = function () {
      _this2.setState({
        sorting: true
      });
    }, _this2.handleShowCopyLevelModal = function (levelId) {
      _this2.setState({
        copyLevelModalVisible: true,
        copyLevelModalObject: {
          schoolLevel: _this2.props.schoolLevels.find(function (level) {
            return level._id === levelId;
          }),
          name: '',
          slug: '',
          shortName: '',
          fieldErrors: {}
        }
      });
    }, _this2.handleCopyLevelModalFieldChange = function (param, event) {
      var copyLevelModalObject = _this2.state.copyLevelModalObject;


      copyLevelModalObject[param] = event.target.value;

      _this2.setState({
        copyLevelModalObject: copyLevelModalObject
      });
    }, _this2.handleHideCopyLevelModal = function () {
      _this2.setState({
        copyLevelModalVisible: false
      });
    }, _this2.handleSaveCopyLevelModal = function () {
      var copyLevelModalObject = _this2.state.copyLevelModalObject;


      var fieldErrors = {};
      if (!copyLevelModalObject.name) {
        fieldErrors.name = 'Champs requis';
      }
      if (!copyLevelModalObject.shortName) {
        fieldErrors.shortName = 'Champs requis';
      }
      if (!copyLevelModalObject.slug) {
        fieldErrors.slug = 'Champs requis';
      }

      copyLevelModalObject.fieldErrors = fieldErrors;

      _this2.setState({ copyLevelModalObject: copyLevelModalObject });

      if ((0, _keys2.default)(fieldErrors).length === 0) {
        _this2.props.dispatch((0, _copy.copySchoolLevel)({
          schoolLevelId: copyLevelModalObject.schoolLevel._id,
          name: copyLevelModalObject.name,
          shortName: copyLevelModalObject.shortName,
          slug: copyLevelModalObject.slug
        }));
      }
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(SchoolLevels, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./SchoolLevels.scss');

      var _props2 = this.props,
          schoolLevels = _props2.schoolLevels,
          copying = _props2.copying,
          user = _props2.user;
      var _state = this.state,
          sorting = _state.sorting,
          copyLevelModalVisible = _state.copyLevelModalVisible,
          copyLevelModalObject = _state.copyLevelModalObject;

      var orderedSchoolLevels = [];
      var references = [];

      if (schoolLevels && schoolLevels.length > 0) {
        orderedSchoolLevels = schoolLevels.filter(function (level) {
          return typeof user.managedSchoolLevels === 'undefined' || user.managedSchoolLevels.length === 0 || user.managedSchoolLevels.indexOf(level._id) > -1;
        }).sort(function (first, second) {
          return first.rank - second.rank;
        });
        references = schoolLevels.map(function (schoolLevel) {
          return {
            _id: schoolLevel._id,
            label: schoolLevel.name,
            index: schoolLevel.rank
          };
        });
      }

      return _react2.default.createElement(
        'div',
        { className: styles.schoolLevels },
        _react2.default.createElement(
          'section',
          { className: styles.box },
          _react2.default.createElement(
            'h1',
            { className: styles.boxTitle },
            'Niveaux scolaires'
          ),
          _react2.default.createElement('div', { className: styles.boxBar })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { activeClassName: styles.activeItem,
                  className: styles.createLevelButton,
                  to: '/schoollevels/new' },
                'Cr\xE9er un niveau'
              ),
              _react2.default.createElement(
                'button',
                { className: styles.createLevelButton,
                  onClick: this.handleStartSorting },
                'Trier les niveaux'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              !sorting ? _react2.default.createElement(
                'table',
                { className: styles.listing },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      '#'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Nom'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Abbr\xE9viation'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'URL'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Nombre de chapitres'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Publi\xE9'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Ouvert'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '\xA0'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  orderedSchoolLevels ? orderedSchoolLevels.map(function (schoolLevel, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index },
                      _react2.default.createElement(
                        'td',
                        null,
                        schoolLevel.rank
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { activeClassName: styles.activeItem, className: styles.schoolLevelLink, to: '/schoollevels/' + schoolLevel._id },
                          schoolLevel.name
                        )
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        schoolLevel.shortName
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        schoolLevel.slug
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        schoolLevel.chapters.length
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        schoolLevel.published ? 'Oui' : 'Non'
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        schoolLevel.accessible ? 'Oui' : 'Non'
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-copy',
                          'aria-hidden': 'true',
                          title: 'Copier le niveau',
                          onClick: _this3.handleShowCopyLevelModal.bind(null, schoolLevel._id) })
                      )
                    );
                  }) : _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      { colSpan: '6' },
                      'Aucun niveau.'
                    )
                  )
                )
              ) : _react2.default.createElement(_reactDraggableList2.default, {
                itemKey: '_id',
                template: SchoolLevelListItem,
                list: references,
                onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
                  return _this3.onListChange(newList, movedItem, oldIndex, newIndex);
                },
                container: function container() {
                  return document.body;
                }
              })
            )
          )
        ),
        copyLevelModalVisible && _react2.default.createElement(
          _components.Modal,
          { onCancel: this.handleHideCopyLevelModal, onSave: this.handleSaveCopyLevelModal, saving: copying },
          _react2.default.createElement(
            'p',
            null,
            'Copie du niveau : ',
            copyLevelModalObject.schoolLevel.name
          ),
          _react2.default.createElement(
            'form',
            { className: styles.form },
            _react2.default.createElement(
              'div',
              { className: styles.line },
              _react2.default.createElement(
                'label',
                { className: styles.inputFieldLabel, htmlFor: 'name' },
                'Nom'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'name', onChange: this.handleCopyLevelModalFieldChange.bind(null, 'name'), className: styles.inputFieldInput }),
              _react2.default.createElement(
                'span',
                null,
                copyLevelModalObject.fieldErrors.name
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.line },
              _react2.default.createElement(
                'label',
                { className: styles.inputFieldLabel, htmlFor: 'shortName' },
                'Abbr\xE9viation'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'shortName', onChange: this.handleCopyLevelModalFieldChange.bind(null, 'shortName'), className: styles.inputFieldInput }),
              _react2.default.createElement(
                'span',
                null,
                copyLevelModalObject.fieldErrors.shortName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.line },
              _react2.default.createElement(
                'label',
                { className: styles.inputFieldLabel, htmlFor: 'slug' },
                'URL'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'slug', onChange: this.handleCopyLevelModalFieldChange.bind(null, 'slug'), className: styles.inputFieldInput }),
              _react2.default.createElement(
                'span',
                null,
                copyLevelModalObject.fieldErrors.slug
              )
            )
          )
        )
      );
    }
  }]);
  return SchoolLevels;
}(_react.Component), _class3.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  copying: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object.isRequired
}, _temp3)) || _class2) || _class2);
exports.default = SchoolLevels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SchoolLevels/SchoolLevels.js
// module id = 1208
// module chunks = 0